import "./bootstrap";

// import "flowbite";

// Swiper
import Swiper from "swiper";
import {
    Navigation,
    Pagination,
    Keyboard,
    Mousewheel,
    Thumbs,
    Zoom,
} from "swiper/modules";
window.Swiper = Swiper;
window.Pagination = Pagination;
window.Navigation = Navigation;
window.Keyboard = Keyboard;
window.Mousewheel = Mousewheel;
window.Thumbs = Thumbs;
window.Zoom = Zoom;

import "swiper/css";
import "swiper/css/zoom";

// Lazy load
import LazyLoad from "vanilla-lazyload";
window.LazyLoad = LazyLoad;
window.lazyLoadInstance = new LazyLoad({});

window.addEventListener(
    "LazyLoad::Initialized",
    function (event) {
        window.lazyLoadInstance = event.detail.instance;
    },
    false,
);

// Toastr
import toastr from "toastr";
toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-bottom-right",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
};
window.toastr = toastr;
window.addEventListener("toast", (event) => {
    let toast = event.detail[0];
    toastr[toast.type ?? "success"](toast.message ?? "");
});

// CropperJS
import "cropperjs/dist/cropper.css";
import Cropper from "cropperjs";
window.Cropper = Cropper;

// SweetAlert2
import Swal from "sweetalert2";
window.Swal = Swal;

// Icon
import "iconify-icon";

// ChartJS
import Chart from "chart.js/auto";
window.Chart = Chart;

// Date FNS
import {
    formatDistance,
    fromUnixTime,
    parse,
    parseISO,
    toDate,
    isAfter,
    format,
    addHours,
} from "date-fns";
import { it } from "date-fns/locale";
window.formatDistance = formatDistance;
window.DateFnsLocaleIt = it;
window.fromUnixTime = fromUnixTime;
window.parse = parse;
window.parseISO = parseISO;
window.toDate = toDate;
window.isAfter = isAfter;
window.format = format;
window.addHours = addHours;

// Livewire / Alpine JS
import {
    Livewire,
    Alpine,
} from "../../vendor/livewire/livewire/dist/livewire.esm";
import Tooltip from "@ryangjchandler/alpine-tooltip";
import collapse from "@alpinejs/collapse";
import sort from "@alpinejs/sort";
import mask from "@alpinejs/mask";
import focus from "@alpinejs/focus";
import intersect from "@alpinejs/intersect";

Alpine.plugin(collapse);
Alpine.plugin(sort);
Alpine.plugin(mask);
Alpine.plugin(focus);
Alpine.plugin(intersect);
Alpine.plugin(
    Tooltip.defaultProps({
        interactive: true,
        allowHTML: true,
        theme: "dark",
    }),
);
Livewire.start();

Livewire.hook("request", ({ fail }) => {
    fail(({ status, preventDefault }) => {
        if (status === 419) {
            preventDefault();

            window.location.reload();
        }
    });
});

// Alpine JS Custom components
import "./components";

document.querySelectorAll('a[href^="#"]:not([href="#"])').forEach((anchor) => {
    anchor.addEventListener("click", function (e) {
        e.preventDefault();

        const offset = this.dataset.offset
            ? parseInt(this.dataset.offset, 10)
            : 96;
        const id = this.getAttribute("href").substring(1);
        const target = document.getElementById(id);

        if (target) {
            // target.scrollIntoView({
            //     behavior: "smooth",
            //     block: "start",
            // });

            const y = target.getBoundingClientRect().top + window.pageYOffset - offset;

            window.scrollTo({top: y, behavior: 'smooth'});

            history.pushState(null, "", "#" + id);
        }
    });
});

// DataLayer helpers
import "./datalayer";
